// Enhanced Datasets Page JavaScript - Institutional Grade

document.addEventListener('DOMContentLoaded', function() {
    console.log('Datasets page loaded');
    
    // Initialize all components
    initializeAnimations();
    initializeModal();
    initializeDatasetPreview();
    initializeFormHandling();
    initializeScrollAnimations();
    initializeParticleBackground();

});

// Enhanced scroll animations for institutional feel
function initializeScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
                
                // Stagger animations for grids
                if (entry.target.classList.contains('fiscal-datasets-grid') || 
                    entry.target.classList.contains('fiscal-stats-grid') ||
                    entry.target.classList.contains('fiscal-compliance-grid')) {
                    const items = entry.target.children;
                    Array.from(items).forEach((item, index) => {
                        setTimeout(() => {
                            item.classList.add('animate-in');
                        }, index * 100);
                    });
                }
            }
        });
    }, observerOptions);

    // Observe all animatable elements
    const animatableElements = document.querySelectorAll(`
        .fiscal-hero-content,
        .fiscal-stats-grid,
        .fiscal-datasets-grid,
        .fiscal-compliance-grid,
        .fiscal-methodology-content,
        .fiscal-integration-content,
        .fiscal-cta-content
    `);
    
    animatableElements.forEach(el => observer.observe(el));
}

// Particle background for hero section
function initializeParticleBackground() {
    const heroSection = document.querySelector('.fiscal-hero-section.datasets-hero');
    const particlesContainer = document.querySelector('.fiscal-hero-particles');
    
    if (!heroSection || !particlesContainer) return;

    // Create floating particles
    for (let i = 0; i < 50; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.cssText = `
            position: absolute;
            width: ${Math.random() * 4 + 2}px;
            height: ${Math.random() * 4 + 2}px;
            background: rgba(74, 222, 128, ${Math.random() * 0.5 + 0.2});
            border-radius: 50%;
            left: ${Math.random() * 100}%;
            top: ${Math.random() * 100}%;
            animation: float ${Math.random() * 10 + 10}s ease-in-out infinite;
            animation-delay: ${Math.random() * 10}s;
            box-shadow: 0 0 10px rgba(74, 222, 128, 0.3);
        `;
        particlesContainer.appendChild(particle);
    }

    // Add particle animation CSS
    const style = document.createElement('style');
    style.textContent = `
        @keyframes float {
            0%, 100% { 
                transform: translateY(0px) translateX(0px) scale(1); 
                opacity: 0.3; 
            }
            25% { 
                transform: translateY(-30px) translateX(15px) scale(1.1); 
                opacity: 0.6; 
            }
            50% { 
                transform: translateY(-60px) translateX(-10px) scale(0.9); 
                opacity: 1; 
            }
            75% { 
                transform: translateY(-30px) translateX(-15px) scale(1.1); 
                opacity: 0.6; 
            }
        }
        
        .animate-in {
            animation: slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }
        
        @keyframes slideInUp {
            from {
                opacity: 0;
                transform: translateY(30px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    `;
    document.head.appendChild(style);
}

// Enhanced animations
function initializeAnimations() {
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Enhanced hover effects for dataset cards
    const datasetCards = document.querySelectorAll('.fiscal-dataset-card');
    datasetCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-12px) scale(1.02)';
            this.style.boxShadow = '0 25px 70px rgba(0, 0, 0, 0.7)';
        });
        
        card.addEventListener('mouseleave', function() {
            this.style.transform = '';
            this.style.boxShadow = '';
        });
    });

    // Parallax effect for background sections
    window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        const parallaxElements = document.querySelectorAll('.fiscal-hero-section, .fiscal-methodology-section, .fiscal-integration-section');
        
        parallaxElements.forEach(element => {
            const speed = 0.5;
            element.style.transform = `translateY(${scrolled * speed}px)`;
        });
    });
}

// Enhanced modal functionality
function initializeModal() {
    const modal = document.getElementById('demoModal');
    const modalContent = modal?.querySelector('.modal-content');
    
    if (!modal) return;

    // Close modal function
    window.closeDemoModal = function() {
        modal.classList.remove('show');
        document.body.style.overflow = '';
        
        // Reset form
        const form = modal.querySelector('#demoForm');
        if (form) {
            form.reset();
            hideMessages();
        }
    };

    // Open modal function
    window.openDemoModal = function() {
        modal.classList.add('show');
        document.body.style.overflow = 'hidden';
        
        // Focus first input
        setTimeout(() => {
            const firstInput = modal.querySelector('input[type="text"]');
            if (firstInput) firstInput.focus();
        }, 300);
    };

    // Close on background click
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeDemoModal();
        }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('show')) {
            closeDemoModal();
        }
    });

    // Prevent modal content click from closing modal
    if (modalContent) {
        modalContent.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    }
}

// Dataset preview functionality
function initializeDatasetPreview() {
    window.openDatasetPreview = function(datasetId) {
        // Create preview modal
        const previewModal = createPreviewModal(datasetId);
        document.body.appendChild(previewModal);
        
        setTimeout(() => {
            previewModal.classList.add('show');
        }, 10);
        
        // Close preview modal
        const closePreview = () => {
            previewModal.classList.remove('show');
            setTimeout(() => {
                document.body.removeChild(previewModal);
            }, 300);
        };
        
        previewModal.addEventListener('click', function(e) {
            if (e.target === previewModal || e.target.classList.contains('close-preview')) {
                closePreview();
            }
        });
    };
}

function createPreviewModal(datasetId) {
    const modal = document.createElement('div');
    modal.className = 'modal preview-modal';
    
    // Create modal structure safely using DOM methods
    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content preview-content';
    
    // Header
    const header = document.createElement('div');
    header.className = 'preview-header';
    
    const title = document.createElement('h3');
    title.textContent = `Dataset Preview: ${getDatasetName(datasetId)}`;
    
    const closeBtn = document.createElement('button');
    closeBtn.className = 'close-preview';
    closeBtn.textContent = '×';
    
    header.appendChild(title);
    header.appendChild(closeBtn);
    
    // Body
    const body = document.createElement('div');
    body.className = 'preview-body';
    
    // Chart section
    const chartDiv = document.createElement('div');
    chartDiv.className = 'preview-chart';
    
    const canvas = document.createElement('canvas');
    canvas.id = `previewChart-${datasetId}`;
    canvas.width = 400;
    canvas.height = 200;
    
    chartDiv.appendChild(canvas);
    
    // Info section
    const infoDiv = document.createElement('div');
    infoDiv.className = 'preview-info';
    
    const infoTitle = document.createElement('h4');
    infoTitle.textContent = 'Sample Data Points';
    
    const dataTable = document.createElement('div');
    dataTable.className = 'data-table';
    dataTable.innerHTML = generateSampleData(datasetId); // This is safe as generateSampleData returns static HTML
    
    const actions = document.createElement('div');
    actions.className = 'preview-actions';
    
    const requestBtn = document.createElement('button');
    requestBtn.className = 'fiscal-btn fiscal-btn-primary';
    requestBtn.textContent = 'Request Full Access';
    requestBtn.onclick = openDemoModal;
    
    actions.appendChild(requestBtn);
    infoDiv.appendChild(infoTitle);
    infoDiv.appendChild(dataTable);
    infoDiv.appendChild(actions);
    
    body.appendChild(chartDiv);
    body.appendChild(infoDiv);
    
    modalContent.appendChild(header);
    modalContent.appendChild(body);
    modal.appendChild(modalContent);
    
    // Add preview modal styles
    const style = document.createElement('style');
    style.textContent = `
        .preview-modal .modal-content {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            max-width: 800px;
            height: auto;
            max-height: 80vh;
            border-radius: 1rem;
            right: auto;
        }
        
        .preview-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.5rem;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .preview-header h3 {
            margin: 0;
            color: white;
            font-size: 1.25rem;
        }
        
        .close-preview {
            background: none;
            border: none;
            color: rgba(255, 255, 255, 0.7);
            font-size: 1.5rem;
            cursor: pointer;
            padding: 0.5rem;
            border-radius: 50%;
            transition: all 0.2s ease;
        }
        
        .close-preview:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;
        }
        
        .preview-body {
            padding: 1.5rem;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
        }
        
        .preview-chart {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 0.5rem;
            padding: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 200px;
        }
        
        .data-table {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 0.5rem;
            padding: 1rem;
            font-family: monospace;
            font-size: 0.875rem;
            color: rgba(255, 255, 255, 0.9);
            margin-bottom: 1rem;
        }
        
        .preview-actions {
            text-align: center;
        }
        
        @media (max-width: 768px) {
            .preview-body {
                grid-template-columns: 1fr;
                gap: 1rem;
            }
        }
    `;
    document.head.appendChild(style);
    
    return modal;
}

function getDatasetName(datasetId) {
    const names = {
        'search': 'Google Search Trends',
        'images': 'Google Images',
        'news_google': 'Google News',
        'shopping': 'Google Shopping',
        'youtube': 'YouTube Search',
        'amazon': 'Amazon Search',
        'baidu': 'Baidu Search',
        'reddit': 'Reddit Analytics',
        'tiktok': 'TikTok Trends',
        'instagram': 'Instagram Insights',
        'news_sentiment': 'News Sentiment',
        'webtraffic': 'Web Traffic Analytics',
        'mobile_apps': 'Mobile App Intelligence',
        'wikipedia': 'Wikipedia Analytics',
        'custom': 'Custom Data Solutions',
        'proprietary': 'Proprietary Signals'
    };
    return names[datasetId] || 'Unknown Dataset';
}

function generateSampleData(datasetId) {
    // Generate realistic sample data based on dataset type
    const sampleData = [];
    const dates = [];
    
    // Generate last 7 days
    for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        dates.push(date.toISOString().split('T')[0]);
    }
    
    dates.forEach(date => {
        let value;
        switch(datasetId) {
            case 'search':
            case 'images':
            case 'news_google':
            case 'shopping':
            case 'youtube':
                value = Math.floor(Math.random() * 100);
                break;
            case 'webtraffic':
                value = Math.floor(Math.random() * 1000000);
                break;
            case 'news_sentiment':
                value = (Math.random() * 2 - 1).toFixed(3); // -1 to 1
                break;
            default:
                value = Math.floor(Math.random() * 1000);
        }
        sampleData.push(`${date}: ${value}`);
    });
    
    return sampleData.join('<br>');
}

// Enhanced form handling
function initializeFormHandling() {
    const form = document.getElementById('demoForm');
    if (!form) return;

    // Form validation
    const validateForm = (formData) => {
        const required = ['first_name', 'last_name', 'email', 'phone', 'job_title', 'company', 'institution_type'];
        const missing = required.filter(field => !formData.get(field)?.trim());
        
        if (missing.length > 0) {
            throw new Error(`Please fill in all required fields: ${missing.join(', ')}`);
        }
        
        // Email validation
        const email = formData.get('email');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            throw new Error('Please enter a valid email address');
        }
        
        return true;
    };

    // Enhanced form submission
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const submitButton = form.querySelector('.submit-button');
        const originalText = submitButton.textContent;
        
        try {
            // Show loading state
            submitButton.textContent = 'Submitting...';
            submitButton.disabled = true;
            hideMessages();
            
            const formData = new FormData(form);
            
            // Validate form
            validateForm(formData);
            
            // Convert to JSON
            const data = Object.fromEntries(formData.entries());
            data.source = 'datasets_page';
            data.timestamp = new Date().toISOString();
            
            // Submit form
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': window.csrfToken || '',
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success) {
                showSuccessMessage();
                form.reset();
                
                // Auto-close modal after success
                setTimeout(() => {
                    closeDemoModal();
                }, 3000);
            } else {
                throw new Error(result.message || 'Submission failed');
            }
            
        } catch (error) {
            console.error('Form submission error:', error);
            showErrorMessage(error.message);
        } finally {
            // Restore button state
            submitButton.textContent = originalText;
            submitButton.disabled = false;
        }
    });

    // Real-time validation feedback
    const inputs = form.querySelectorAll('input[required], select[required]');
    inputs.forEach(input => {
        input.addEventListener('blur', function() {
            if (this.value.trim()) {
                this.style.borderColor = 'rgba(74, 222, 128, 0.5)';
            } else {
                this.style.borderColor = 'rgba(248, 113, 113, 0.5)';
            }
        });
        
        input.addEventListener('input', function() {
            if (this.style.borderColor === 'rgba(248, 113, 113, 0.5)' && this.value.trim()) {
                this.style.borderColor = '';
            }
        });
    });
}

// Message display functions
function showSuccessMessage() {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (errorMsg) errorMsg.style.display = 'none';
    if (successMsg) {
        successMsg.style.display = 'block';
        successMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}

function showErrorMessage(message) {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) {
        errorMsg.style.display = 'block';
        errorMsg.querySelector('br').nextSibling.textContent = message || 'Please try again later.';
        errorMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}

function hideMessages() {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';
}

// Performance optimizations
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Throttled scroll handler for better performance
const throttledScrollHandler = debounce(() => {
    const scrolled = window.pageYOffset;
    const parallaxElements = document.querySelectorAll('.fiscal-hero-section, .fiscal-methodology-section, .fiscal-integration-section');
    
    parallaxElements.forEach(element => {
        const speed = 0.3;
        element.style.transform = `translateY(${scrolled * speed}px)`;
    });
}, 16); // ~60fps

// Replace scroll event listener with throttled version
window.removeEventListener('scroll', () => {});
window.addEventListener('scroll', throttledScrollHandler, { passive: true });

// Load Intercom for customer support
const intercomScript = document.createElement('script');
intercomScript.src = '/static/shared/js/intercom-init.js';
intercomScript.async = true;
document.head.appendChild(intercomScript);

 